import { useTranslation } from '@frontend/i18n';
import {
  Button,
  CheckboxField,
  ModalControlTriggerProps,
  NakedButton,
  Text,
  useControlledField,
} from '@frontend/design-system';
import { BulkCreateStepId } from '../../BulkCreateModal/bulk-create-modal';
import { BULK_CREATE_STEPS } from '../../BulkCreateModal/bulk-create-steps-key-title';
import { styles } from '../styles';

type MobileToolBarProps = {
  selectionState: 'all' | 'some' | 'none';
  count: number;
  onClear: () => void;
  onSelectAll: () => void;
  triggerProps: ModalControlTriggerProps;
  isSelectionDisabled: boolean;
  toggleInitialStep: (stepId: BulkCreateStepId) => void;
};
export const MobileToolBar = ({
  selectionState,
  count,
  onClear,
  onSelectAll,
  triggerProps,
  isSelectionDisabled,
  toggleInitialStep,
}: MobileToolBarProps) => {
  const { t } = useTranslation('payments');
  const selectProps = useControlledField({
    onChange: (val) => (!val ? onClear() : onSelectAll()),
    type: 'checkbox',
    value: selectionState !== 'none',
  });
  return (
    <div css={styles.topToolbarMobile.container}>
      <CheckboxField
        {...selectProps}
        name='delete'
        label=''
        indeterminate={selectionState === 'some'}
        disabled={isSelectionDisabled}
      />
      {selectionState === 'none' && (
        <Text color='light' size='medium'>
          {t('Select All')}
        </Text>
      )}
      <div
        css={[
          styles.topToolbarMobile.selectionActions,
          selectionState === 'none' && styles.topToolbarMobile.selectionActionsHidden,
        ]}
      >
        <NakedButton
          css={styles.topToolbarMobile.nakedButton}
          {...triggerProps}
          onClick={() => {
            toggleInitialStep(BULK_CREATE_STEPS.VALIDATE_USERS.id);
            triggerProps.onClick?.();
          }}
        >
          <Text color='primary' size='medium'>{`${count} selected`}</Text>
        </NakedButton>
        <Button
          {...triggerProps}
          variant='secondary'
          size='small'
          iconName='payment-request-small'
          css={styles.topToolbarMobile.button}
          trackingId='bulk-collections-send-sms-button-from-mobile-list'
          onClick={() => {
            toggleInitialStep(BULK_CREATE_STEPS.SEND_SMS.id);
            triggerProps.onClick?.();
          }}
        >
          <Text size='small'>{t('Text-to-Pay')}</Text>
        </Button>
      </div>
    </div>
  );
};
